<div class="page-layout blank p-24 main-container" fusePerfectScrollbar>
    <div *ngIf="!isMobileDevice">
        <p class="text-center font-size-22 font-weight-800 invalid-device">
            Please use a mobile device connected to your company's network for clocking in and out.
        </p>
    </div>
    <div *ngIf="isMobileDevice">
        <p class="text-center font-size-22 font-weight-800">Welcome {{employeeDetails?.employeeName}}</p> 
        <p class="text-center font-size-16 font-weight-600">
            You are currently 
            <span *ngIf="employeeDetails?.isAlreadyClockIn" style="color: green;" class="font-weight-800">Clocked In</span>
            <span *ngIf="!employeeDetails?.isAlreadyClockIn" style="color: red;" class="font-weight-800">Not Clocked In</span> 
            for the day.
        </p>
        <div class="text-center">
            <button *ngIf="!employeeDetails?.isAlreadyClockIn" pButton pRipple class="p-button-success pull-right p-mr-2"
                    (click)="showConfirmationDialog()">
                Clock In
            </button>
            <button *ngIf="employeeDetails?.isAlreadyClockIn" pButton pRipple class="p-button-danger pull-right p-mr-2"
                    (click)="showConfirmationDialog()">
                Clock Out
            </button>
        </div>
        <p class="text-center font-weight-600">Date: {{currentDate | date:'dd/MM/YYYY'}}</p>
        <div class="card table-container">
            <p-table #dt [value]="employeeDetails?.clockInOutDetails" [scrollable]="true" [rows]="5"
                 [paginator]="false" [rowHover]="true" styleClass="p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Clock In</th>
                        <th>Clock Out</th>
                        <th>Total Time</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>{{ rowData.clockIn | date: 'HH:mm:ss' }}</td>
                        <td>{{ rowData.clockOut ? (rowData.clockOut | date: 'HH:mm:ss') : 'N/A' }}</td>
                        <td>{{ formatTotalTime(rowData.totalTime) }}</td>                    
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3">
                            <div class="notFound">
                                No Clock In/Out Data Available.
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <p class="text-center">Your total work time is {{ formatTotalTime(employeeDetails?.totalWorkTime)}}</p>
    </div>    
</div>

<p-dialog [(visible)]="isConfirmationDialogVisible" [style]="{width: '300px', height: '160px'}" header="Confirmation"
    [modal]="true" styleClass="p-fluid" (onHide)="hideConfirmationDialog()" [contentStyle]="{ 'overflow': 'visible' }">
    <ng-template pTemplate="content">
        <div class="p-field">
            <p *ngIf="!employeeDetails?.isAlreadyClockIn">Are you want to clock in for the day?</p>
            <p *ngIf="employeeDetails?.isAlreadyClockIn">Are you want to clock out for the day?</p>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text p-button-danger"
            (click)="hideConfirmationDialog()"></button>
        <button pButton pRipple label="Yes" icon="pi pi-check" class="p-button-text"
            (click)="verifyQRForAttendance()"></button>
    </ng-template>
</p-dialog>